module.exports = __webpack_public_path__ + "static/TS-Calcifer-e1958bf055f6832cda1b196f0647651b.gif";